export default __webpack_public_path__ + "static/media/13.2ce075c8.png";